module.exports = __webpack_public_path__ + "static/img/DIAKALLPACAMBIOS.9d919aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DIAKALLPACAMBIOS.png
// module id = rHN/
// module chunks = 1